import React from 'react';
import { Link } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { AppBar, Divider, Toolbar, Typography } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

import Avatar from 'components/atoms/Avatar';

import LogoOmega from 'assets/Logo.svg';

import { IHeaderProps } from './types';
import useStyles from './style';

const Header = ({
  username,
  onClickLogout,
  onClickMenuButton,
  pageTitle,
}: IHeaderProps) => {
  const classes = useStyles();

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <div className={classes.menuGroup}>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={onClickMenuButton}
          >
            <MenuIcon />
          </IconButton>

          <Link className={classes.logo} to="/">
            <img
              alt="Logo da Serena | Energia Limpa, ilimitada e acessível."
              src={LogoOmega}
              aria-label="Serena | Energia Limpa, ilimitada e acessível."
            />
          </Link>

          <Typography className={classes.pageTitle}>{pageTitle}</Typography>
        </div>

        <div className={classes.menuGroup}>
          <div className={classes.userInfo}>
            <span className={classes.userName}>{` ${username}`}</span>
          </div>
          <Avatar username={username} />

          <Divider
            orientation="vertical"
            variant="middle"
            className={classes.divider}
          />

          <IconButton
            color="inherit"
            onClick={onClickLogout}
            aria-label="Fazer o logout"
          >
            <ExitToAppIcon className={classes.icon} />
          </IconButton>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
